/* unplugin-vue-components disabled */import script from "./topTag.vue?vue&type=script&setup=true&lang=js"
export * from "./topTag.vue?vue&type=script&setup=true&lang=js"

import "./topTag.vue?vue&type=style&index=0&id=7df36012&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7df36012"]])

export default __exports__